<template>
    <div>
        <div>
            <b-row no-gutters>
                <b-col>
                    <BookingNav></BookingNav>
                </b-col>
            </b-row>
        </div>
        <div>
            <div class="content-body">
                <div class="content-inside">
                    <b-row no-gutters>
                        <b-col sm="12" md="8">
                            <div id="booking-settings" class="modal-form">
                                <b-row no-gutters>
                                    <b-col sm="12" md="3">
                                        <h6 class="main-label">Cancellation</h6>
                                    </b-col>
                                    <b-col>
                                        <switches v-model="settings.enable_cancellation" 
                                                  theme="custom"
                                                  color="primary"
                                                  type-bold="true"
                                                  text-enabled="On"
                                                  text-disabled="Off"
                                                  style="position: absolute; top: -18px;">
                                        </switches>
                                        <label for="" class="secondary-label" style="position: absolute; left: 60px;">Allow cancellation before class</label>
                                        <b-row no-gutters>
                                            <b-col sm="12" md="3">
                                                <b-form-group
                                                    id="durationGroup"
                                                    label="Duration"
                                                    label-for="duration"
                                                    class="secondary-label mt-5 mb-2"
                                                >
                                                    <b-form-input id="duration" type="number" v-model="settings.cancellation_duration"></b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col></b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col>
                                        <hr class="form-divider">
                                    </b-col>
                                </b-row>
                                <b-row no-gutters>
                                    <b-col sm="12" md="3">
                                        <h6 class="main-label">Instructor</h6>
                                    </b-col>
                                    <b-col>
                                        <switches v-model="settings.display_instructor"
                                                  theme="custom"
                                                  color="primary"
                                                  type-bold="true"
                                                  text-enabled="On"
                                                  text-disabled="Off"
                                                  style="position: absolute; top: -18px;">
                                        </switches>
                                        <label for="" class="secondary-label" style="position: absolute; left: 60px;">Visibility of instructor in app</label>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2 mt-2">
                                    <b-col>
                                        <hr class="form-divider">
                                    </b-col>
                                </b-row>
                                <b-row no-gutters>
                                    <b-col sm="12" md="3">
                                        <h6 class="main-label">Ratings</h6>
                                    </b-col>
                                    <b-col>
                                        <switches v-model="settings.enable_ratings"
                                                  theme="custom"
                                                  color="primary"
                                                  type-bold="true"
                                                  text-enabled="On"
                                                  text-disabled="Off"
                                                  style="position: absolute; top: -18px;">
                                        </switches>
                                        <label for="" class="secondary-label" style="position: absolute; left: 60px;">Allow ratings after class</label>
                                        <switches v-model="settings.enable_comments"
                                                theme="custom"
                                                color="primary"
                                                type-bold="true"
                                                text-enabled="On"
                                                text-disabled="Off"
                                                style="position: absolute; top: 26px;">
                                        </switches>
                                        <label for="" class="secondary-label" style="position: absolute; top: 44px; left: 60px;">Allow comments</label>
                                        <b-row no-gutters style="margin-top: 80px;">
                                            <b-col>
                                                <b-form-group id="pushNotificationMessageGroup"
                                                              label="Push Notification Message"
                                                              label-for="pushNotificationMessage"
                                                              class="secondary-label mb-2"
                                                              description="Message above is the default notification sent to the Customer. You can modify it to make it personalized."
                                                              :invalid-feedback="errorMessage('push_template')"
                                                              :state="isValid('push_template')"
                                                >
                                                    <b-form-textarea id="pushNotificationMessage"
                                                                     v-model="settings.push_template"
                                                                     maxlength="200"
                                                                     :rows="3"
                                                                     :max-rows="6">
                                                    </b-form-textarea>
                                                </b-form-group>
                                            </b-col>
                                            <b-col sm="1" md="1">
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>
                                                <label class="secondary-label mb-2">Phrases</label>
                                            </b-col>
                                        </b-row>
                                        <b-row no-gutters v-for="(item, index) in settings.phrases" :key="index">
                                            <b-col>
                                                <b-form-group
                                                    id="phrasesGroup"
                                                >
                                                    <b-form-input v-model="item.name" ref="phrase" maxlength="50"></b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col sm="1" md="1">
                                                <img src="../../assets/images/actions/delete.svg" alt="Delete Button" class="action-button booking-delete-phrase" v-bind:class="{ 'd-none': (index == 0) || (index == settings.phrases.length - 1) }" @click="deletePhrase(item)">
                                                <img class="phrases-add-button mx-auto" src="../../assets/images/icons/add.svg" alt="Add Icon" @click="addPhrase()" v-bind:class="{ 'd-none': (index == 0 && settings.phrases.length > 1) || (index < settings.phrases.length - 1) }">
                                            </b-col>
                                        </b-row>
                                        <b-row no-gutters>
                                            <b-col>
                                                <b-form-group
                                                    class="secondary-label"
                                                    :invalid-feedback="errorMessage('phrases')"
                                                    :state="isValid('phrases')"
                                                >
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col>
                                        <hr class="form-divider">
                                    </b-col>
                                </b-row>
                                <b-row no-gutters>
                                    <b-col sm="12" md="3">
                                        <h6 class="main-label">Room</h6>
                                    </b-col>
                                    <b-col>
                                        <switches v-model="settings.enable_rooms"
                                                  theme="custom"
                                                  color="primary"
                                                  type-bold="true"
                                                  text-enabled="On"
                                                  text-disabled="Off"
                                                  style="position: absolute; top: -18px;"
                                        >
                                        </switches>
                                        <label for="" class="secondary-label" style="position: absolute; left: 60px">Rooms</label>
                                        <br>
                                        <template v-if="branchesWithRooms.length > 0">
                                            <template v-for="branch in branchesWithRooms">
                                                <b-row no-gutters>
                                                    <b-col>
                                                        <b-form-group
                                                            label="Branch"
                                                            label-for="branchOne"
                                                            class="secondary-label mt-2 mb-2"
                                                        >
                                                            <b-form-select v-model="branch.uuid" :options="branchOptions" class="mb-3" />
                                                        </b-form-group>
                                                    </b-col>
                                                    <b-col sm="1" md="1"></b-col>
                                                </b-row>
                                                <template v-if="checkBranch(branch.uuid)">
                                                    <template v-for="(room, index) in settings.rooms" v-if="room.branch_uuid === branch.uuid">
                                                        <b-row no-gutters>
                                                            <b-col>
                                                                <b-form-group id="roomOneGroup"
                                                                            horizontal
                                                                            :label-cols="2"
                                                                            breakpoint="md"
                                                                            label="Room"
                                                                            label-for="roomOne"
                                                                            class="booking-horizontal-label mb-2">
                                                                    <b-form-input :ref="'room-' + index" v-model="room.name"></b-form-input>
                                                                </b-form-group>
                                                            </b-col>
                                                            <b-col sm="2" md="2">
                                                                <img 
                                                                    v-bind:class="{ 'd-none': (indexOfRoomByBranch(branch.uuid, room.name)  == 0 && lengthOfRoomsByBranch(branch.uuid) > 1) || (indexOfRoomByBranch(branch.uuid, room.name) < lengthOfRoomsByBranch(branch.uuid) - 1) }"
                                                                    class="room-add-button mx-auto" src="../../assets/images/icons/add.svg"
                                                                    alt="Add Icon"
                                                                    @click="addRoom(branch.uuid, branch.name, index, room.uuid, room.name)"
                                                                >
                                                            </b-col>
                                                        </b-row>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <b-row no-gutters>
                                                        <b-col>
                                                            <b-form-group id="roomOneGroup"
                                                                            horizontal
                                                                            :label-cols="2"
                                                                            breakpoint="md"
                                                                            label="Room"
                                                                            label-for="roomOne"
                                                                            class="booking-horizontal-label mb-2">
                                                                <b-form-input :ref="'first-room-' + branch.uuid"></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                        <b-col sm="2" md="2">
                                                            <img 
                                                                class="room-add-button mx-auto"
                                                                src="../../assets/images/icons/add.svg"
                                                                alt="Add Icon"
                                                                @click="addRoom(branch.uuid, branch.name, 'first-room')"
                                                            >
                                                        </b-col>
                                                    </b-row>
                                                </template>
                                            </template>
                                            <b-row no-gutters>
                                                <b-col cols="11">
                                                    <hr>
                                                    <img class="branch-add-button d-inline-block" src="../../assets/images/icons/add.svg" alt="Add Icon" @click="addBranch()">
                                                    <label for="" class="add-branch-label ml-2 d-inline-block align-middle">Add a Branch</label>
                                                </b-col>
                                            </b-row>
                                            <b-row no-gutters>
                                                <b-col>
                                                    <b-form-group
                                                        class="secondary-label mt-1"
                                                        :invalid-feedback="errorMessage('rooms')"
                                                        :state="isValid('rooms')"
                                                    >
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </template>
                                        <template v-else>
                                            <label class="secondary-label mt-3 mb-0">Please add a branch first 
                                                <router-link to="/store">
                                                    <a>here</a>
                                                </router-link>
                                            before adding a room.</label>
                                        </template>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col>
                                        <hr class="form-divider">
                                    </b-col>
                                </b-row>
                                <b-row no-gutters>
                                    <b-col sm="12" md="3">
                                        <h6 class="main-label">Categories</h6>
                                    </b-col>
                                    <b-col>
                                        <div id="category-switch" style="margin-bottom: 36px;">
                                            <switches v-model="settings.enable_categories"
                                                    theme="custom"
                                                    color="primary"
                                                    type-bold="true"
                                                    text-enabled="On"
                                                    text-disabled="Off"
                                                    style="position: absolute; top: -18px;">
                                            </switches>
                                            <label for="" class="secondary-label" style="position: absolute; left: 60px;">Categories</label>
                                        </div>
                                        <b-row no-gutters v-for="(category, index) in settings.categories" v-bind:key="index">
                                            <b-col cols="6">
                                                <b-form-group class="mt-1">
                                                    <b-form-input ref="category" v-model="category.name" placeholder="Enter category"></b-form-input>
                                                </b-form-group>
                                            </b-col>
                                            <b-col v-if="index != 0">
                                                <img src="../../assets/images/actions/delete.svg" alt="Delete Button" class="d-inline-block action-button booking-delete-category" @click="deleteCategory(category)">
                                            </b-col>
                                        </b-row>
                                        <b-row no-gutters>
                                            <b-col cols="11">
                                                <img class="branch-add-button d-inline-block" src="../../assets/images/icons/add.svg" alt="Add Icon" @click="addCategory()">
                                                <label for="" class="add-branch-label ml-2 d-inline-block align-middle">Add a Category</label>
                                            </b-col>
                                        </b-row>
                                        <b-row no-gutters>
                                            <b-col>
                                                <b-form-group
                                                    class="secondary-label mt-1"
                                                    :invalid-feedback="errorMessage('categories')"
                                                    :state="isValid('categories')"
                                                >
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                    </b-col>   
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <b-button size="lg" variant="primary" class="mt-4 save-button" type="submit" :block="true" @click="showModal">Save</b-button>
                                    </b-col>
                                    <b-col cols="9"></b-col>
                                </b-row>
                            </div>
                        </b-col>
                        <b-col sm="12" md="4">
                        </b-col>
                    </b-row>
                </div>
            </div>
            <b-modal ref="myModalRef" title="Confirm Changes">
                <p class="modal-main-message">Do you want to save the changes you made?</p>
                <div slot="modal-footer">
                    <b-button variant="ghost" v-bind:disabled="loading" class="btn-cancel" style="margin-right: .25rem;" @click="hideModal('delete-modal')">
                        Cancel
                    </b-button>
                    <b-button variant="primary" v-bind:disabled="loading" style="margin-left: .25rem;" @click="sendForm()">
                        <template v-if="loading">
                            Saving...
                        </template>
                        <template v-else>
                            Save
                        </template>
                    </b-button>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import BookingNav from "./BookingNav.vue";
import Switches from "vue-switches";
import { mapState } from "vuex";

export default {
    name: "settings",
    data() {
        return {
        };
    },
    computed: {
        ...mapState("bookingSettings", [
            "loading",
            "settings",
            "branches",
            "branchOptions",
            "branchesWithRooms",
            "errors"
        ]),
    },
    components: {
        BookingNav,
        Switches
    },
    created() {
        this.getBranches();
        this.viewSettings();
    },
    methods: {
        async viewSettings() {
            this.$store.dispatch("bookingSettings/viewSettings");
        },
        async getBranches() {
            this.$store.dispatch("bookingSettings/getBranches");
        },
        addCategory() {
            if (!this.settings.categories) {
                this.settings.categories = [];
                this.settings.categories.push({ uuid: "", name: "" });
            } else {
                let lastIndex = this.settings.categories.length - 1;
                let lastItem = this.$refs.category[lastIndex].$el;

                if (lastItem.value != "") {
                    this.settings.categories.push({ uuid: "", name: "" });
                } else {
                    lastItem.focus();
                    // console.log("This field is required. Please enter a value.");
                }
            }
        },
        deleteCategory(category) {
            // console.log(this.settings.categories.indexOf(category));
            this.settings.categories.splice(this.settings.categories.indexOf(category), 1);
        },
        addPhrase() {
            let lastIndex = this.settings.phrases.length - 1;
            let lastItem = this.$refs.phrase[lastIndex].$el;

            if (lastItem.value != "") {
                this.settings.phrases.push({ uuid: "", name: "" });
            } else {
                lastItem.focus();
                // console.log("This field is required. Please enter a value.");
            }
        },
        deletePhrase(phrase) {
            // console.log(this.settings.phrases.indexOf(phrase));
            this.settings.phrases.splice(
                this.settings.phrases.indexOf(phrase),
                1
            );
        },
        async sendForm() {
            let newCategories = [];
            let newRooms = [];
            let newPhrases = [];

            if (this.settings.categories.length > 0) {
                newCategories = this.settings.categories.map(
                    ({ id, merchant_uuid, ...keepAttrs }) => keepAttrs
                ).filter(category => category.name != "");
            }

            if (this.settings.rooms.length > 0) {
                newRooms = this.settings.rooms.map(
                    ({ id, merchant_uuid, ...keepAttrs }) => keepAttrs
                ).filter(room => room.name != "");
            }

            if (this.settings.phrases.length > 0) {
                newPhrases = this.settings.phrases.map(
                    ({ merchant_uuid, ...keepAttrs }) => keepAttrs
                ).filter(phrase => phrase.name != "");
            }

            let param = {
                enable_cancellation: this.settings.enable_cancellation,
                cancellation_duration: this.settings.cancellation_duration,
                display_instructor: this.settings.display_instructor,
                enable_ratings: this.settings.enable_ratings,
                enable_comments: this.settings.enable_comments,
                enable_rooms: this.settings.enable_rooms,
                enable_categories: this.settings.enable_categories,
                push_template: this.settings.push_template,
                categories: newCategories,
                rooms: newRooms,
                phrases: newPhrases
            };

            let _this = this;
            await this.$store
                .dispatch("bookingSettings/saveSettings", param)
                .then(function() {
                    if (_this.errors == null) {
                        _this.hideModal();
                        _this.viewSettings();
                    } else {
                        console.log(_this.errors);
                        _this.hideModal();
                    }
                });
        },
        checkBranch(uuid) {
            if (this.settings.rooms.length > 0) {
                var found = this.settings.rooms.some(function (el) {
                    return el.branch_uuid === uuid;
                });
            } else {
                var found = false;
            }
            return found;
        },
        indexOfRoomByBranch(branchUuid, roomName) {
            let rooms = this.settings.rooms.filter(room => room.branch_uuid === branchUuid);
            let index = rooms.findIndex(room => room.name === roomName);
            return index;
        },
        lengthOfRoomsByBranch(branchUuid) {
            let rooms = this.settings.rooms.filter(room => room.branch_uuid === branchUuid);
            let length = rooms.length;
            return length;
        },
        addRoom(branchUuid, branchName, index, roomUuid, roomName) {
            let room = [];
            if (this.settings.rooms.length > 0) {
                let rooms = this.settings.rooms.filter(room => room.branch_uuid === branchUuid);
            }
            if (index === 'first-room') {
                let refName = 'first-room-' + branchUuid;
                let branch = this.branches.filter(branch => branch.uuid === branchUuid).pop();
                if (!this.settings.rooms) {
                    this.settings.rooms = [];
                }
                this.settings.rooms.push({
                                            uuid: "",
                                            name: this.$refs[refName][0].$el.value,
                                            branch_uuid: branchUuid,
                                            branch_name: branch.name
                                        });
                this.settings.rooms.push({
                                            uuid: "",
                                            name: "",
                                            branch_uuid: branchUuid,
                                            branch_name: branch.name
                                        });
            } else {
                let refName = 'room-' + index;
                let lastRoomEntered = this.$refs[refName][0].$el.value;
                if (lastRoomEntered != "") {
                    this.settings.rooms.push({
                                                uuid: "",
                                                name: "",
                                                branch_uuid: branchUuid,
                                                branch_name: branchName
                                            });
                }
                else {
                    this.$refs[refName][0].$el.focus();
                }
            }
        },
        addBranch() {
            this.branchesWithRooms.push({"uuid": ""});
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }

            return this.errors.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors.errors[field] ? false : true;
        },
        showModal() {
            this.$refs.myModalRef.show()
        },
        hideModal() {
            this.$refs.myModalRef.hide()
        },
    }
};
</script>
<style lang="scss">
#category-switch {
    .vue-switcher input {
        top: 14px;
        height: 53%;
    }
}
</style>
